import { createElement } from 'react';
import { ToolbarSpacerProps } from '.';
import cx from 'classnames';
import cn from './ToolbarSpacer.css.json';
import './ToolbarSpacer.css';

export const ToolbarSpacer = (props: ToolbarSpacerProps) => {
  return (
    <div
      data-testid={props.testId}
      className={cx(cn.toolbarSpacer, props.className)}
      style={props.style}
    />
  );
};
